<template lang="pug">
div.animated.fadeIn
  div.row.justify-content-center
    div.col-md-6
      div.clearfix
        h1.float-left.display-3.mr-4
          | 404
        h4.pt-3
          | Oops! You're lost.
        p.text-muted
          | The page you are looking for was not found.
      div.input-prepend.input-group
        span.input-group-addon
          i.fa.fa-search
        input.form-control(id='prependedInput' size='16' type='text' placeholder='What are you looking for?')
        span.input-group-btn
          button.btn.btn-info(type='button')
            | Search
</template>

<script>
export default {
  name: 'dashboard',
}
</script>



// WEBPACK FOOTER //
// src/views/404.vue?d1b7550e